/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Duration_Too_ShortInputs */

const en_us2_workout_after_duration_too_short = /** @type {(inputs: Workout_After_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too short`)
};

const pt_br2_workout_after_duration_too_short = /** @type {(inputs: Workout_After_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curta demais`)
};

const es_419_workout_after_duration_too_short = /** @type {(inputs: Workout_After_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy corta`)
};

const pt_pt2_workout_after_duration_too_short = /** @type {(inputs: Workout_After_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiado curta`)
};

const fr_fr2_workout_after_duration_too_short = /** @type {(inputs: Workout_After_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop courte`)
};

const de_de2_workout_after_duration_too_short = /** @type {(inputs: Workout_After_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu kurz`)
};

const it_it2_workout_after_duration_too_short = /** @type {(inputs: Workout_After_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppo corta`)
};

/**
* | output |
* | --- |
* | "Too short" |
*
* @param {Workout_After_Duration_Too_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_duration_too_short = /** @type {((inputs?: Workout_After_Duration_Too_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Duration_Too_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_duration_too_short(inputs)
	if (locale === "es-419") return es_419_workout_after_duration_too_short(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_duration_too_short(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_duration_too_short(inputs)
	if (locale === "de-DE") return de_de2_workout_after_duration_too_short(inputs)
	if (locale === "it-IT") return it_it2_workout_after_duration_too_short(inputs)
	return en_us2_workout_after_duration_too_short(inputs)
});
export { workout_after_duration_too_short as "workout-after.duration_too_short" }